export default function Hero() {
  const handleScroll = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="inicio"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/eed4836bf5aa8b45b112ffe98c9fc186.jpg"
          alt="Mediación legal profesional"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0d1f35]/85 via-[#1B3A5C]/70 to-[#0d1f35]/50" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-32 flex flex-col items-start">
        <span className="inline-flex items-center gap-2 text-[#3D9E8C] text-sm font-semibold tracking-widest uppercase mb-6">
          <span className="w-8 h-px bg-[#3D9E8C]" />
          Mediación Legal Profesional
        </span>
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight max-w-3xl mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
          Resuelve tus conflictos<br />
          <span className="text-[#3D9E8C]">con elegancia</span><br />
          y eficacia
        </h1>
        <p className="text-white/75 text-lg max-w-xl leading-relaxed mb-10">
          Desde 2015, hemos ayudado a miles de personas y empresas a encontrar soluciones pacíficas, confidenciales y duraderas. La mediación es ahora <strong className="text-white/90">obligatoria</strong> por ley en España.
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
          <button
            onClick={() => handleScroll('contacto')}
            className="px-8 py-4 bg-[#3D9E8C] text-white text-base font-semibold rounded-full hover:bg-[#2d8a78] transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            Solicitar Consulta Gratuita
          </button>
          <button
            onClick={() => handleScroll('servicios')}
            className="px-8 py-4 border-2 border-white/60 text-white text-base font-semibold rounded-full hover:bg-white/10 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            Ver Servicios
          </button>
        </div>

        {/* Stats */}
        <div className="mt-20 flex flex-wrap gap-10">
          {[
            { value: '+2.500', label: 'Casos Resueltos' },
            { value: '95%', label: 'Tasa de Éxito' },
            { value: '+10', label: 'Años de Experiencia' },
            { value: '100%', label: 'Confidencialidad' },
          ].map((stat) => (
            <div key={stat.label} className="flex flex-col">
              <span className="text-3xl font-bold text-white" style={{ fontFamily: "'Playfair Display', serif" }}>
                {stat.value}
              </span>
              <span className="text-white/60 text-sm mt-1">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/50 text-xs tracking-widest uppercase">Descubrir</span>
        <i className="ri-arrow-down-line text-white/50 text-xl" />
      </div>
    </section>
  );
}
